export default __webpack_public_path__ + "static/media/close.2a034df8.svg";